import React from 'react';
import { Grid, Card, CardContent, Typography, Avatar, Divider, Box, CssBaseline, Container, CardMedia, Stack, Button, AppBar, Toolbar } from '@mui/material';
import HorizontalImageCarousel from 'components/HorizontalImageCarousel';
import { Link } from 'react-router-dom';
import MediaInkSection from 'components/MediaInkSections';
import EyeButton from 'components/EyeButton';
import RotatingTextCircle from 'components/RotatingTextCircle';
import RotatingDataCircle from 'components/RotatingDataCircle';
import Footer from 'components/layout/main/Footer';

const images = [
  "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl1.jpeg?alt=media&token=e6883e87-42f1-447a-a808-027cb689effc",
  "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl2.jpeg?alt=media&token=a12809a0-b150-4493-bc81-db5ac8138bae",
  "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl3.jpeg?alt=media&token=218c1933-5b3d-4c04-b4ff-dc75ec4bcf51",
  "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl4.jpeg?alt=media&token=b069c22e-27b1-45da-ab41-7e52f0c35709",
  "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl5.jpeg?alt=media&token=7086677d-2325-4017-bbc2-1d699e0012f2",
  "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl6.jpeg?alt=media&token=2a531306-356e-4255-9e8a-80e4fc306566",
  "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl7.jpeg?alt=media&token=146ac31b-9b5b-47ae-a1f4-bb07b5db899f",
  "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fphotos%2Fecatl8.jpeg?alt=media&token=46e13fd8-be46-4882-9b56-b8f1e1af8655",
];

const ChrisProfile = () => {

  return (
    <>
     <Container maxWidth={true} disableGutters>
      {/* Sección: Perfil Básico */}
      <CssBaseline />


      {/*<AppBar
        position="fixed"
        sx={{
          boxShadow: 0,
          bgcolor: 'black',
          backgroundImage: 'none',
          width:"100%",
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            variant="regular"
            sx={(theme) => ({
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexShrink: 0,
                   })}
          >
            <Box
              sx={{
                flexGrow: 1,
                display: 'flex',
                alignItems: 'center',
                ml: '-18px',
                px: 0,
              }}
            >
              <Link to="/home" style={{ display: 'inline-block' }}>
                <img
                  src="https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/leidenfrost.svg?alt=media&token=aa8b35e7-10dc-4f45-9530-63fef6768eca" // reemplaza con tu ruta real
                  alt="Brand Logo"
                  style={{ width: 140, height: 'auto',
                  cursor: 'pointer', objectFit: 'contain' }}
                />
              </Link>
  
              
            </Box>
          </Toolbar>
        </Container>
      </AppBar>*/}
      

      {/*<MediaInkSection ></MediaInkSection>*/}

      <Box elevation={0} sx={{ borderRadius: 0, position: 'relative' }}>
        <Box
          component="video"
          src={
            "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fvideo%2Fholywars.mp4?alt=media&token=39098c08-3a99-41da-8e97-d249b4cc9cb2"
          }
          sx={{ height: '100vh', objectFit: 'cover', width: '100%' }}
          controls = {false}
          autoPlay
          muted
          loop
        />
        {/* Caja de contenido sobrepuesta (Overlay) */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end', // Alinea todo hacia abajo
          alignItems: 'flex-start',   // Alinea todo hacia la izquierda
          color: '#fff',
          textAlign: 'start',
          // Padding responsivo: menos espacio en celular, más en PC
          p: { xs: 4, md: 10 }, 
          // Este degradado oscurece la parte inferior para que el texto sea 100% legible
          background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 60%)',
        }}
      >
        {/* Título Principal */}
        <Typography 
          variant="h2" 
          fontWeight="bold" 
          sx={{ 
            mb: 1, 
            fontSize: { xs: '2.5rem', sm: '3.5rem', md: '5rem' },
            textShadow: '2px 2px 4px rgba(0,0,0,0.5)' // Sombrilla extra
          }}
        >
          Donde la lógica se convierte en arte
        </Typography>

        {/* Subtítulo o Descripción */}
        <Typography 
          variant="h5" 
          sx={{ 
            mb: 4, 
            maxWidth: '600px', // Evita que el texto sea muy largo en PC
            fontSize: { xs: '1rem', md: '1.5rem' },
            fontWeight: 'medium'
          }}
        >
          l software no es solo código; es el lienzo en blanco del siglo XXI. En Leidenfrost.io no nos limitamos a construir herramientas, diseñamos realidades. Desde arquitecturas de sistemas complejos hasta el renderizado en tiempo real de mundos inmersivos.
        </Typography>

        {/* Opcional: Un botón de llamada a la acción */}
        {/*<Button 
          variant="contained" 
          size="large"
          sx={{ 
            backgroundColor: '#fff', 
            color: '#000',
            fontWeight: 'bold',
            px: 4,
            py: 1.5,
            '&:hover': { backgroundColor: '#e0e0e0' }
          }}
        >
          Explorar
        </Button>*/}
        <EyeButton onClick={() => console.log("Navegando a la siguiente sección...")} />
      </Box>

      {/* Brand logo at top-left */}
      <Box
        sx={{
          position: 'absolute',
          top: { xs: 16, md: 32 }, // Un poco más de margen en PC
          left: { xs: 16, md: 32 },
          zIndex: 2,
        }}
      >
        <Link to="/home" style={{ display: 'inline-block' }}>
          <img
            src="https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/leidenfrost.svg?alt=media&token=aa8b35e7-10dc-4f45-9530-63fef6768eca"
            alt="Brand Logo"
            style={{ 
              width: 140, 
              height: 'auto',
              cursor: 'pointer', 
              objectFit: 'contain' 
            }}
          />
        </Link>
      </Box>
      </Box>
 

    <Container
      maxWidth={false}
      sx={{
        pt: 2,
        pb: 2,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundColor: "#5638e5",
        overflow: "hidden", // ensures text doesn't overflow container
      }}
    >
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent="center"
        component="main"
      >
        <Grid item xs={12}>
          {/* First line - moves right */}
          <Box
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              width: "100%",
            }}
          >
            <Typography
              variant="h1"
              fontWeight="bold"
              align="center"
              sx={{
                display: "inline-block",
                color: "#2d1d76",
                fontSize: 200,
                animation: "moveRight 30s linear infinite",
                "@keyframes moveRight": {
                  "0%": { transform: "translateX(-100%)" },
                  "100%": { transform: "translateX(100%)" },
                },
              }}
            >
              Explore the world
            </Typography>
          </Box>

          {/* Second line - moves left */}
          <Box
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              width: "100%",
            }}
          >
            <Typography
              variant="h1"
              fontWeight="bold"
              align="center"
              sx={{
                display: "inline-block",
                color: "#2d1d76",
                fontSize: 200,
                animation: "moveLeft 10s linear infinite",
                "@keyframes moveLeft": {
                  "0%": { transform: "translateX(100%)" },
                  "100%": { transform: "translateX(-100%)" },
                },
              }}
            >
              of prize kingdoms 
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Container>

      <Container maxWidth={false}  sx={{
        pb:24,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        }}
      >
        <Grid container spacing={2} alignItems="center" justifyContent="center" component="main">
          <Grid item xs={12} sm={4} md={4} >
            <Stack spacing={3} sx={{px:4}}>
                <Typography variant="h4" align="left" color="white" fontWeight="bold">
                Traemos tus ideas al mundo real.
                </Typography>
                <Divider style={{ background: 'white' }}/>
                <Typography variant="body1" align="left" color="white">
                Somos un grupo de asociados expertos en desarrollo.
                </Typography>
                <Button variant="special">
                Conocer más
              </Button>
            </Stack>
          </Grid>
          <Grid item xs={12} sm={8} md={8} >
            <Box elevation={0} sx={{ borderRadius: 0, position: 'relative' }}>
              <Box
                component="video"
                src={
                  "https://firebasestorage.googleapis.com/v0/b/leidenfrost-web.appspot.com/o/media%2Fvideo%2FfiorinaFury.mp4?alt=media&token=f64963d2-0c8a-44d9-a937-243404f00151"
                }
                sx={{ height: '50vh', objectFit: 'cover', width: '100%' }}
                controls = {false}
                autoPlay
                muted
                loop
                />
                {/* Caja de contenido sobrepuesta (Overlay) */}
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end', // Alinea todo hacia abajo
                  alignItems: 'flex-end',   // Alinea todo hacia la izquierda
                  color: '#fff',
                  textAlign: 'start',
                  // Padding responsivo: menos espacio en celular, más en PC
                  p: { xs: 4, md: 10 }, 
                  // Este degradado oscurece la parte inferior para que el texto sea 100% legible
                  background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 60%)',
                }}
              >
                <RotatingDataCircle></RotatingDataCircle>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Container>
    <Footer></Footer>
    </>
  );
};

export default ChrisProfile;
